import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import { useRouter } from "next/router";
import nookies from "nookies";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setEmail,
  setUID,
  setUser,
  signInR,
  updateUser,
} from "redux/slices/authReducer";
import formatUrl from "utils/FormatUrl";
import style from "./MobileDrawerv2.module.css";
import $ from "utils/selectors";
import Acheter from "components/Navbarv2/components/SubMenuComponent/Acheter";
import Vendre from "components/Navbarv2/components/SubMenuComponent/Vendre";
import CreditImmo from "components/Navbarv2/components/SubMenuComponent/CreditImmo";
import LangSwitchIcon from "components/Navbarv2/assets/LangSwitchIcon";
function MobileDrawerv3({
  closeMenu,
  openLoginModal,
  onLogout,
  user,
  menuClicked,
}: {
  closeMenu: () => void;
  openLoginModal: () => void;
  onLogout: () => void;
  user: any;
  menuClicked: any;
}) {
  const dispatch = useDispatch();
  const { t, lang } = useTranslation("navbar");
  const router = useRouter();
  const [logingOut, setLogingOut] = useState(false);
  const [menuToDisplay, setMenuToDisplay] = useState("displayAll");
  const authenticatedRedux = useSelector(
    (store: any) => store?.auth?.authenticated
  );
  const userRedux = useSelector((store: any) => store?.auth?.user);
  const authenticatedProRedux = useSelector(
    (store: any) => store?.auth?.authenticatedPro
  );

  useEffect(() => {
    if (router.pathname.startsWith("/offres-pro")) {
      setMenuToDisplay("OffresPro");
    }
    window.addEventListener("resize", async () => {
      $(".main-nav-height").attr(
        "style",
        `height : calc(${window.innerHeight}px) !important`
      );
    });
  }, []);
  const [showEstimer, setshowEstimer] = useState(false);
  const [showAcheter, setshowAcheter] = useState(false);
  const [showCredit, setshowCredit] = useState(false);
  const [showItems, setshowItems] = useState(false);
  const [showAnnonces, setshowAnnonces] = useState(false);
  const [language, setLanguage] = useState(lang);
  const [openLang, setOpenLang] = useState(false);
  return (
    <div
      className={
        menuClicked
          ? style.mobile_drawer__container2
          : style.mobile_drawer__container2none
      }
    >
      <div>
        {user && user?.id ? (
          !showItems ? (
            <>
              <div className={style.profil}>
                <button
                  className={style.profilItems}
                  style={{ backgroundColor: "transparent" }}
                  onClick={() => setshowItems(true)}
                >
                  <div className={style.profilUserName}>
                    <p
                      style={{
                        fontWeight: "500",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "black",
                        marginBottom: "0px",
                      }}
                    >
                      {user && user?.id
                        ? `${
                            user.firstName
                              ? user.firstName
                              : user.firstname
                              ? user.firstname
                              : ""
                          } ${
                            user.lastName
                              ? user.lastName
                              : user.lastname
                              ? user.lastname
                              : ""
                          }`
                        : t("Connexion")}
                    </p>
                    <p
                      style={{
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "21px",
                        color: "#00B4FF",
                        marginBottom: "0px",
                      }}
                    >
                      {t("Mon compte")}
                    </p>
                  </div>
                  {/* {!showItems ? (
                  <div>
                    <svg
                      width="10"
                      height="19"
                      viewBox="0 0 10 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M0.999999 1.5L9 9.5L1 17.5"
                        stroke="#00B4FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                ) : null} */}
                </button>
              </div>
            </>
          ) : (
            <>
              <ul style={{ margin: "0px" }}>
                <li
                  className={style.profilItems}
                  // style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.16)" }}
                >
                  <button
                    // className={style.itemtitle1}
                    style={{
                      backgroundColor: "transparent",
                      fontWeight: "500",
                      fontSize: "16px",
                      lineHeight: "24px",
                      padding: "0px",
                    }}
                    onClick={() => setshowItems(false)}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <span>
                        <svg
                          width="14"
                          height="10"
                          viewBox="0 0 14 10"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.22853 0.616007L0.109865 4.73467C-0.0366217 4.88124 -0.0366217 5.11878 0.109865 5.26534L4.22853 9.38401C4.3752 9.53067 4.61253 9.53067 4.75853 9.38401L5.37187 8.77067C5.44316 8.69937 5.48277 8.60238 5.48176 8.50155C5.48076 8.40073 5.43923 8.30454 5.36653 8.23467L2.84453 5.81334H13.6185C13.8252 5.81334 13.9939 5.64534 13.9939 5.43801V4.56334C13.9939 4.35605 13.8258 4.18801 13.6185 4.18801H2.84453L5.36653 1.76601C5.4394 1.69623 5.48105 1.60001 5.48205 1.49913C5.48305 1.39825 5.44333 1.30122 5.37187 1.23001L4.75853 0.616674C4.61205 0.47063 4.37502 0.47063 4.22853 0.616674V0.616007Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                      <span style={{ color: "black" }}>{t("Retour")}</span>
                    </span>
                  </button>
                </li>
              </ul>
            </>
          )
        ) : null}
        {user?.isPro ? (
          <>
            <div className={style.btnsContainer}>
              {user?.isPro ? (
                <a
                  rel="nofollow"
                  href={formatUrl(`/${lang}/espace-pro`, lang)}
                  className={style.btnPro}
                >
                  <span>
                    <svg
                      width="18"
                      height="19"
                      viewBox="0 0 18 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g id="Vector">
                        <path
                          d="M17.4861 13.0876C17.3237 10.7686 15.1382 8.45557 12.3686 8.51515C10.483 8.51028 9.16871 9.06148 8.11371 10.1209C7.0526 11.1864 6.58991 12.47 6.7117 13.9132C6.82475 15.2515 7.4581 16.3733 8.54147 17.2528C9.61437 18.1242 10.8771 18.5598 12.3145 18.4934C13.8584 18.4221 15.1565 17.8409 16.1779 16.7717C17.177 15.7257 17.583 14.4761 17.4861 13.0876ZM15.2582 12.7322C15.1836 13.193 15.0915 13.6514 15.0037 14.1106C14.9457 14.4141 14.8828 14.7169 14.8248 15.0205C14.789 15.2081 14.6676 15.2952 14.4193 15.2956C13.641 15.2969 12.8632 15.2961 12.0849 15.2961C11.3795 15.2961 10.6742 15.2863 9.9688 15.2989C9.3372 15.3102 9.42319 15.1846 9.33152 14.802C9.16478 14.1045 9.02641 13.4009 8.89721 12.6965C8.87626 12.583 8.92733 12.4128 9.01419 12.3423C9.08709 12.2827 9.27522 12.2953 9.38739 12.3358C9.83698 12.4979 10.28 12.6767 10.7178 12.8643C10.8518 12.9219 10.9051 12.8817 10.9823 12.7905C11.2691 12.4509 11.5624 12.1161 11.8593 11.7842C11.9544 11.6776 12.2648 11.6971 12.3669 11.8122C12.6633 12.1453 12.9596 12.4785 13.246 12.8189C13.3141 12.8996 13.3551 12.9085 13.4551 12.8663C13.8955 12.6819 14.3368 12.4975 14.7894 12.3415C14.9156 12.2981 15.1133 12.3091 15.2168 12.3759C15.287 12.4213 15.2766 12.6126 15.2573 12.7322H15.2582Z"
                          fill="#4609F0"
                        />
                        <path
                          d="M6.06132 7.01274C8.09887 7.0634 9.8719 5.61287 9.75579 3.56129C9.66064 1.87853 8.21367 0.533368 6.2285 0.50054C4.2071 0.467306 2.65537 1.97377 2.6462 3.74691C2.65624 5.59098 4.25643 6.96775 6.06132 7.01274Z"
                          fill="#4609F0"
                        />
                        <path
                          d="M9.0609 8.5881C8.3708 8.21685 7.59166 7.97895 6.76626 7.92099C6.03731 7.86993 5.29833 7.8833 4.58947 8.08594C3.28872 8.4576 2.23677 9.16402 1.47771 10.2125C0.767978 11.1929 0.447592 12.2872 0.506955 13.4722C0.516558 13.6611 0.640085 13.7892 0.838689 13.7892C2.56153 13.7892 4.28436 13.7868 6.0072 13.7847C6.01942 13.7738 6.03164 13.7628 6.04386 13.7519C6.04343 13.2591 6.05696 12.7683 6.18179 12.2852C6.44543 11.2642 6.94391 10.356 7.74575 9.6151C8.15212 9.2394 8.62397 8.9257 9.0609 8.5881Z"
                          fill="#4609F0"
                        />
                      </g>
                    </svg>
                  </span>
                  <span>{t("Espace professionnel")}</span>
                </a>
              ) : null}
              <a
                href={
                  user?.isPro
                    ? formatUrl(`/${lang}/espace-pro/annonces/publier`, lang)
                    : formatUrl(`/${lang}/user/annonces/publier`, lang)
                }
                className={style.annonceBtn}
              >
                <span>
                  <svg
                    width="16"
                    height="17"
                    viewBox="0 0 16 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="Icon/Outline/sm-view-grid-add">
                      <path
                        id="Icon"
                        d="M11.3334 9.83335V13.8334M9.33341 11.8334H13.3334M4.00008 7.16669H5.33341C6.06979 7.16669 6.66675 6.56973 6.66675 5.83335V4.50002C6.66675 3.76364 6.06979 3.16669 5.33341 3.16669H4.00008C3.2637 3.16669 2.66675 3.76364 2.66675 4.50002V5.83335C2.66675 6.56973 3.2637 7.16669 4.00008 7.16669ZM10.6667 7.16669H12.0001C12.7365 7.16669 13.3334 6.56973 13.3334 5.83335V4.50002C13.3334 3.76364 12.7365 3.16669 12.0001 3.16669H10.6667C9.93037 3.16669 9.33341 3.76364 9.33341 4.50002V5.83335C9.33341 6.56973 9.93037 7.16669 10.6667 7.16669ZM4.00008 13.8334H5.33341C6.06979 13.8334 6.66675 13.2364 6.66675 12.5V11.1667C6.66675 10.4303 6.06979 9.83335 5.33341 9.83335H4.00008C3.2637 9.83335 2.66675 10.4303 2.66675 11.1667V12.5C2.66675 13.2364 3.2637 13.8334 4.00008 13.8334Z"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                  </svg>
                </span>
                <span>{t("PUBLIER UNE ANNONCE")}</span>
              </a>
            </div>
          </>
        ) : null}
        <div className={style.items}>
          {!showItems ? (
            <ul style={{ padding: "0px", margin: "0px" }}>
              <li className={style.navItem}>
                <span className={style.itemtitle1}>
                  <span
                    style={{
                      display: "flex",
                      // justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      borderBottom: showAcheter
                        ? "1px solid rgba(0, 0, 0, 0.16)"
                        : "none",
                    }}
                  >
                    <a
                      href={formatUrl("/list.htm?transaction_type=Vente", lang)}
                      rel={"nofollow noopener noreferrer noindex"}
                      style={{
                        color: router.pathname.startsWith("/acheter")
                          ? "rgba(0, 180, 255, 1)"
                          : "black",
                        padding: "16px",
                        width: "100%",
                      }}
                    >
                      <span>{t("Acheter")}</span>
                    </a>
                    <span
                      style={{
                        padding: "16px",
                        borderLeft: "1px solid rgba(0, 0, 0, 0.16)",
                        display: "flex",
                        alignItems: "center",
                      }}
                      onClick={() => setshowAcheter(!showAcheter)}
                    >
                      <span
                        className={showAcheter ? style.svg_down : style.svg_up}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Icon/Outline/chevron-right">
                            <path
                              id="Icon"
                              d="M19 9L12 16L5 9"
                              stroke="#00B4FF"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  {showAcheter ? (
                    <div
                      style={{
                        padding: "0px",
                        display: "flex",
                        flexDirection: "column",
                        // gap: "24px",
                        // paddingLeft: "5px",
                      }}
                    >
                      <Acheter lang={lang} t={t} />
                    </div>
                  ) : null}
                </span>
              </li>

              <li className={style.navItem}>
                <span className={style.itemtitle1}>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      borderBottom: showEstimer
                        ? "1px solid rgba(0, 0, 0, 0.16)"
                        : "none",
                    }}
                  >
                    <a
                      href={formatUrl("/vendre-rapidement", lang)}
                      style={{
                        color: router.pathname.startsWith("/vendre-rapidement")
                          ? "rgba(0, 180, 255, 1)"
                          : "black",
                        padding: "16px",
                        width: "100%",
                      }}
                    >
                      <span>{t("Vendre")}</span>
                    </a>

                    <span
                      style={{
                        padding: "16px",
                        borderLeft: "1px solid rgba(0, 0, 0, 0.16)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className={showEstimer ? style.svg_down : style.svg_up}
                        onClick={() => setshowEstimer(!showEstimer)}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Icon/Outline/chevron-right">
                            <path
                              id="Icon"
                              d="M19 9L12 16L5 9"
                              stroke="#00B4FF"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  {showEstimer ? (
                    <Vendre lang={lang} t={t} fromMobile={true} />
                  ) : // <ul
                  //   style={{
                  //     padding: "0px",
                  //     display: "flex",
                  //     flexDirection: "column",
                  //     // gap: "24px",
                  //     // paddingLeft: "5px",
                  //   }}
                  // >
                  //   <li className={style.subItem1}>
                  //     <a
                  //       data-tracking="click"
                  //       data-value=""
                  //       className={style.subitemtitle}
                  //       href={formatUrl(`/${lang}/vendre-rapidement`, lang)}
                  //     >
                  //       {t("Vendre rapidement")}
                  //     </a>
                  //   </li>
                  //   <li className={style.subItem}>
                  //     <a
                  //       data-tracking="click"
                  //       data-value=""
                  //       className={style.subitemtitle}
                  //       href={formatUrl(
                  //         `/${lang}/estimation-immobiliere`,
                  //         lang
                  //       )}
                  //     >
                  //       {t("Estimation Immobilière")}
                  //     </a>
                  //   </li>
                  //   <li className={style.subItem}>
                  //     <a
                  //       data-tracking="click"
                  //       data-value=""
                  //       className={style.subitemtitle}
                  //       href={formatUrl(
                  //         `/${lang}/publier-une-annonce-proprietaire`,
                  //         lang
                  //       )}
                  //     >
                  //       {t("Publier une annonce")}
                  //     </a>
                  //   </li>
                  //   <li className={style.subItem}>
                  //     <a
                  //       data-tracking="click"
                  //       data-value=""
                  //       className={style.subitemtitle}
                  //       href={formatUrl(
                  //         `/${lang}/comment-reussir-votre-vente-immobilier-au-maroc`,
                  //         lang
                  //       )}
                  //     >
                  //       {t("Comment vendre votre maison ?")}
                  //     </a>
                  //   </li>
                  // </ul>
                  null}
                </span>
              </li>
              <li className={style.navItem}>
                <span className={style.itemtitle1}>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      borderBottom: showCredit
                        ? "1px solid rgba(0, 0, 0, 0.16)"
                        : "none",
                    }}
                    onClick={() => setshowCredit(!showCredit)}
                  >
                    <span
                      style={{
                        color: showCredit ? "rgba(0, 180, 255, 1)" : "black",
                        padding: "16px",
                        width: "100%",
                      }}
                    >
                      {t("Crédit immobilier")}
                    </span>
                    <span
                      style={{
                        padding: "16px",
                        borderLeft: "1px solid rgba(0, 0, 0, 0.16)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className={showCredit ? style.svg_down : style.svg_up}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Icon/Outline/chevron-right">
                            <path
                              id="Icon"
                              d="M19 9L12 16L5 9"
                              stroke="#00B4FF"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  {showCredit ? (
                    // <ul
                    //   style={{
                    //     padding: "0px",
                    //     display: "flex",
                    //     flexDirection: "column",
                    //     // gap: "24px",
                    //     // paddingLeft: "5px",
                    //   }}
                    // >
                    //   <li className={style.subItem1}>
                    //     <a
                    //       data-tracking="click"
                    //       data-value=""
                    //       className={style.subitemtitle}
                    //       href={formatUrl(
                    //         `/${lang}/credit-immobilier-maroc`,
                    //         lang
                    //       )}
                    //     >
                    //       {t("Crédit immobilier")}
                    //     </a>
                    //   </li>
                    //   <li className={style.subItem}>
                    //     <a
                    //       data-tracking="click"
                    //       data-value=""
                    //       className={style.subitemtitle}
                    //       href={formatUrl(
                    //         `/${lang}/credit-immobilier/demander-un-credit`,
                    //         lang
                    //       )}
                    //     >
                    //       {t("Demander un crédit")}
                    //     </a>
                    //   </li>
                    //   <li className={style.subItem}>
                    //     <a
                    //       data-tracking="click"
                    //       data-value=""
                    //       className={style.subitemtitle}
                    //       href={formatUrl(
                    //         `/${lang}/credit-immobilier/simulateur-credit-immobilier`,
                    //         lang
                    //       )}
                    //     >
                    //       {t("Calculateur de budget")}
                    //     </a>
                    //   </li>
                    //   <li className={style.subItem}>
                    //     <a
                    //       data-tracking="click"
                    //       data-value=""
                    //       className={style.subitemtitle}
                    //       href={formatUrl(
                    //         `/${lang}/credit-immobilier/simulateur-de-mensualite-credit`,
                    //         lang
                    //       )}
                    //     >
                    //       {t("Calculateur de Mensualité")}
                    //     </a>
                    //   </li>
                    // </ul>
                    <CreditImmo lang={lang} t={t} fromMobile={true} />
                  ) : null}
                </span>
              </li>
              <li className={style.navItem}>
                <a
                  data-tracking="click"
                  data-value=""
                  className={style.itemtitle}
                  href={formatUrl(`/${lang}/prix-immobilier-maroc`, lang)}
                >
                  {t("Prix immobiliers")}
                </a>
              </li>
              <li className={style.navItem}>
                <a
                  data-tracking="click"
                  data-value=""
                  className={style.itemtitle}
                  rel={"nofollow noopener noreferrer noindex"}
                  href={formatUrl(
                    `/${lang}/list.htm?transaction_type=Location`,
                    lang
                  )}
                >
                  {t("Louer")}
                </a>
              </li>
              <li
                data-tracking="click"
                data-value=""
                className={style.navItemLang}
                onClick={() => {
                  setOpenLang(!openLang);
                }}
              >
                <div className={style.itemtitlelang}>
                  <LangSwitchIcon />
                  {lang === "fr"
                    ? "Français"
                    : lang === "en"
                    ? "English"
                    : "العربية"}
                  <span style={{ rotate: openLang ? "0deg" : "180deg" }}>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.59883 12.3994L10.1988 6.79941L15.7988 12.3994"
                        stroke="#00111A"
                        stroke-width="1.6"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                {openLang ? (
                  <div className={style.langOptions}>
                    <a
                      className={language == "fr" ? style.activeLang : ""}
                      href={`/fr${router.asPath}`}
                      onClick={() => {
                        setLanguage("fr");
                      }}
                    >
                      Français
                    </a>
                    {/* <a
                  className={language == "en" ? style.activeLang : ""}
                  href={`/en${router.asPath}`}
                  onClick={() => {
                    setLanguage("en");
                  }}
                >
                  English
                </a> */}
                    <a
                      className={language == "ar" ? style.activeLang : ""}
                      href={`/ar${router.asPath}`}
                      onClick={() => {
                        setLanguage("ar");
                      }}
                    >
                      العربية
                    </a>
                  </div>
                ) : null}
              </li>
              {/* <li className={style.navItem}>
              <a
                data-tracking="click"
                data-value=""
                className={style.itemtitle}
                href={formatUrl(`/${lang}/agence-immobiliere-maroc`, lang)}
              >
                {t("Trouver une agence")}
              </a>
            </li> */}
              {/* {user?.isPro ? (
              <div
                style={{
                  borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px",
                  padding: "23px 23px 17px 23px",
                }}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "13px" }}
                >
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.00067 0.5C5.74102 0.5 3.90957 2.33136 3.90957 4.59091V5.27273C3.90957 7.53227 5.74102 9.36364 8.00067 9.36364C10.2603 9.36364 12.0918 7.53227 12.0918 5.27273V4.59091C12.0918 2.33136 10.2603 0.5 8.00067 0.5ZM5.33985 11.1041C3.33863 11.6271 1.45085 12.6117 0.754683 13.5171C0.131473 14.3271 0.724735 15.5 1.74683 15.5H14.2532C15.2753 15.5 15.8685 14.3265 15.2453 13.5158C14.5491 12.6103 12.662 11.6271 10.6615 11.1041C9.94554 11.7185 9.0173 12.0909 8.00067 12.0909C6.98335 12.0909 6.0558 11.7178 5.33985 11.1041Z"
                      fill="#460AF0"
                    />
                  </svg>
                  <a
                    data-tracking="click"
                    data-value=""
                    style={{
                      backgroundColor: "transparent",

                      fontWeight: "500",
                      fontSize: "16px",
                      lineHeight: "24px",
                      color: "#460af0",
                    }}
                    href={formatUrl(`/${lang}/espace-pro`, lang)}
                  >
                    {t("Accéder à mon espace pro")}
                  </a>
                </span>
                <span>
                  <svg
                    width="10"
                    height="18"
                    viewBox="0 0 10 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.999999 1L9 9L1 17"
                      stroke="#460AF0"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
              </div>
            ) : null} */}
            </ul>
          ) : (
            <ul style={{ padding: "0px", margin: "0px" }}>
              {/* <li className={style.navItem}>
              <a
              data-tracking="click"
              data-value=""
                className={style.itemtitle1}
                href={formatUrl(`/${lang}/estimation/map`, lang)}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  <span className={style.iconestimation}>
                    <svg
                      width="16"
                      height="17"
                      viewBox="0 0 16 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13 6.5C13 7.93437 12.5344 9.25937 11.75 10.3344L15.7063 14.2937C16.0969 14.6844 16.0969 15.3188 15.7063 15.7094C15.3156 16.1 14.6812 16.1 14.2906 15.7094L10.3344 11.75C9.25938 12.5375 7.93438 13 6.5 13C2.90937 13 0 10.0906 0 6.5C0 2.90937 2.90937 0 6.5 0C10.0906 0 13 2.90937 13 6.5ZM3.25 6.75V8.75C3.25 9.16562 3.58438 9.5 4 9.5C4.41563 9.5 4.75 9.16562 4.75 8.75V6.75C4.75 6.33437 4.41563 6 4 6C3.58438 6 3.25 6.33437 3.25 6.75ZM5.75 3.75V8.75C5.75 9.16562 6.08437 9.5 6.5 9.5C6.91563 9.5 7.25 9.16562 7.25 8.75V3.75C7.25 3.33437 6.91563 3 6.5 3C6.08437 3 5.75 3.33437 5.75 3.75ZM8.25 5.75V8.75C8.25 9.16562 8.58438 9.5 9 9.5C9.41563 9.5 9.75 9.16562 9.75 8.75V5.75C9.75 5.33437 9.41563 5 9 5C8.58438 5 8.25 5.33437 8.25 5.75Z"
                        fill="#00B4FF"
                      />
                    </svg>
                  </span>
                  <span className={style.black_link}>
                    {t("Nouvelle estimation")}
                  </span>
                </span>
              </a>
            </li> */}

              {/* <li className={style.navItem}>
                        <span className={style.itemtitle1}>
                            <span style={{display: 'flex',alignItems: 'center' ,gap: '10px'}}>
                                <span className={style.iconestimation}>
                                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.61896 0C0.724483 0 0 0.724483 0 1.61896V2.42843V3.23791V12.9516C0 13.8461 0.724483 14.5706 1.61896 14.5706H5.80547C6.25231 14.5706 6.61495 14.208 6.61495 13.7611C6.61495 13.3143 6.25312 12.9516 5.80547 12.9516H1.61896V3.23791H12.9516L12.9501 5.80547C12.9501 6.25231 13.3127 6.61495 13.7595 6.61495C14.2064 6.61495 14.569 6.25231 14.569 5.80547V3.23791H14.5706V1.61896C14.5706 0.724483 13.8461 0 12.9516 0H1.61896ZM3.64265 5.66635C3.41923 5.66635 3.23791 5.84767 3.23791 6.07108V6.88056C3.23791 7.10398 3.41923 7.2853 3.64265 7.2853H4.45213C4.67554 7.2853 4.85687 7.10398 4.85687 6.88056V6.07108C4.85687 5.84767 4.67554 5.66635 4.45213 5.66635H3.64265ZM7.2853 5.66635C6.83847 5.66635 6.47582 6.02899 6.47582 6.47582C6.47582 6.92266 6.83847 7.2853 7.2853 7.2853H10.5232C10.97 7.2853 11.3327 6.92266 11.3327 6.47582C11.3327 6.02899 10.97 5.66635 10.5232 5.66635H7.2853ZM12.1438 8.09478C9.95007 8.09478 8.09478 9.95007 8.09478 12.1438C8.09478 14.4095 9.87563 16.1896 12.1422 16.1896C12.9516 16.1896 13.7618 15.9461 14.4093 15.5413L15.6315 16.765C15.9447 17.0783 16.4518 17.0783 16.765 16.765C17.0783 16.4518 17.0783 15.9447 16.765 15.6315L15.5413 14.4093C15.9461 13.7618 16.1896 12.9516 16.1896 12.1422C16.1896 9.87563 14.4095 8.09478 12.1438 8.09478ZM3.64265 8.90426C3.41923 8.90426 3.23791 9.08558 3.23791 9.309V10.1185C3.23791 10.3419 3.41923 10.5232 3.64265 10.5232H4.45213C4.67554 10.5232 4.85687 10.3419 4.85687 10.1185V9.309C4.85687 9.08558 4.67554 8.90426 4.45213 8.90426H3.64265ZM12.1422 9.71374C13.5183 9.71374 14.5706 10.7661 14.5706 12.1422C14.5706 13.5183 13.5183 14.5706 12.1422 14.5706C10.7661 14.5706 9.71374 13.5183 9.71374 12.1422C9.71374 10.7661 10.7661 9.71374 12.1422 9.71374Z" fill="#00B4FF"/>
                                    </svg>
                                </span>
                                <span>
                                    Nouvelle estimation
                                </span>
                            </span>
                        </span>
                    </li> */}
              {/* $$$$$$$$$$$$$$$$$$$$$$$$ */}

              {/* $$$$$$$$$$$$$$$$$$$$$$$$ */}
              <li className={style.MyItem}>
                <a
                  data-tracking="click"
                  data-value=""
                  className={style.myitemtitle1}
                  rel="nofollow"
                  href={formatUrl(`/${lang}/user/saved`, lang)}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span className={style.iconestimation}>
                      <svg
                        width="17"
                        height="14"
                        viewBox="0 0 17 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.58047 8.11695L7.58027 13.4193C7.8293 13.6393 8.15801 13.7619 8.5 13.7619C8.84199 13.7619 9.1707 13.6393 9.41973 13.4193L15.4195 8.11695C16.4289 7.22746 17 5.97966 17 4.67529V4.49299C17 2.29598 15.3232 0.422715 13.0355 0.0612617C11.5215 -0.177612 9.98086 0.290706 8.89844 1.31535L8.5 1.69252L8.10156 1.31535C7.01914 0.290706 5.47852 -0.177612 3.96445 0.0612617C1.67676 0.422715 0 2.29598 0 4.49299V4.67529C0 5.97966 0.571094 7.22746 1.58047 8.11695Z"
                          fill="#00B4FF"
                        />
                      </svg>
                    </span>
                    <span className={style.black_link}>
                      {t("Annonces aimées")}
                    </span>
                  </span>
                </a>
              </li>
              <li className={style.MyItem}>
                <a
                  data-tracking="click"
                  data-value=""
                  className={style.myitemtitle1}
                  rel="nofollow"
                  href={formatUrl(`/${lang}/user/recherches`, lang)}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span className={style.iconestimation}>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Icon/Outline/document-search">
                          <g id="Icon">
                            <path
                              d="M15 14C15 15.6569 13.6569 17 12 17C11.1716 17 10.4216 16.6642 9.87868 16.1213C9.33579 15.5784 9 14.8284 9 14C9 12.3431 10.3431 11 12 11C13.6569 11 15 12.3431 15 14Z"
                              fill="#00B4FF"
                            />
                            <path
                              d="M10 21H17C18.1046 21 19 20.1046 19 19V9.41421C19 9.149 18.8946 8.89464 18.7071 8.70711L13.2929 3.29289C13.1054 3.10536 12.851 3 12.5858 3H7C5.89543 3 5 3.89543 5 5V16M5 21L9.87868 16.1213M9.87868 16.1213C10.4216 16.6642 11.1716 17 12 17C13.6569 17 15 15.6569 15 14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14C9 14.8284 9.33579 15.5784 9.87868 16.1213Z"
                              stroke="#00B4FF"
                              stroke-width="2"
                              stroke-linecap="round"
                            />
                          </g>
                        </g>
                      </svg>
                    </span>
                    <span className={style.black_link}>
                      {t("Mes recherches sauvegardées")}
                    </span>
                  </span>
                </a>
              </li>
              <li className={style.MyItem}>
                <a
                  data-tracking="click"
                  data-value=""
                  className={style.myitemtitle1}
                  rel="nofollow"
                  href={formatUrl(`/${lang}/user/estimates`, lang)}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span className={style.iconestimation}>
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.49912 0C8.17625 0 7.85358 0.112432 7.5905 0.338068L0.279299 6.60795C0.0082478 6.84032 -0.088231 7.24553 0.0917609 7.55753C0.321003 7.95462 0.828298 8.0322 1.15817 7.74929L8.38494 1.55256C8.4512 1.49583 8.54705 1.49583 8.61331 1.55256L15.8401 7.75C15.9726 7.86382 16.1332 7.91903 16.2934 7.91903C16.5396 7.91903 16.7839 7.78788 16.9189 7.53551C17.0837 7.22715 16.9867 6.83767 16.7238 6.61222L15.5854 5.63565V2.54545C15.5854 2.14364 15.2683 1.81818 14.8768 1.81818H14.1682C13.7766 1.81818 13.4595 2.14364 13.4595 2.54545V3.8125L9.40775 0.338068C9.14467 0.112432 8.82199 0 8.49912 0ZM8.49912 2.90909L1.41283 8.9858V14.1818C1.41283 15.1855 2.20649 16 3.1844 16H6.01892C6.60708 16 7.08186 15.5127 7.08186 14.9091V11.2727C7.08186 10.8727 7.40075 10.5455 7.79049 10.5455H9.20775C9.5975 10.5455 9.91638 10.8727 9.91638 11.2727V14.9091C9.91638 15.5127 10.3912 16 10.9793 16H13.8138C14.7918 16 15.5854 15.1855 15.5854 14.1818V8.9858L8.49912 2.90909Z"
                          fill="#00B4FF"
                        />
                      </svg>
                    </span>
                    <span className={style.black_link}>
                      {t("Mes estimations")}
                    </span>
                  </span>
                </a>
              </li>
              <li className={style.MyItemList}>
                <span className={style.myitemtitle1}>
                  <span
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      // alignItems: "center",
                      width: "100%",
                      borderBottom: showAnnonces
                        ? "1px solid rgba(0, 0, 0, 0.16)"
                        : "none",
                    }}
                    onClick={() => setshowAnnonces(!showAnnonces)}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        color: `${showAnnonces ? "#00B4FF" : "black"}`,
                        padding: "16px",
                        width: "100%",
                      }}
                    >
                      <span className={style.iconestimation}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="16"
                          viewBox="0 0 18 16"
                          fill="none"
                        >
                          <path
                            d="M14.2753 0.00036206C14.0306 -0.00632257 13.7789 0.0793076 13.5635 0.277847L12.8379 0.945893L6.18551 3.61436C5.92449 3.73396 5.75456 4.00966 5.75456 4.31514V10.55C5.75456 10.8524 5.92145 11.1267 6.17928 11.2478L12.8379 13.9973L13.5033 14.713C14.1727 15.4329 15.3171 14.9232 15.3171 13.9051V9.51519C16.3099 9.41888 17.0879 8.52283 17.0879 7.42996C17.0879 6.3371 16.3099 5.44104 15.3171 5.34473V1.14527C15.3171 0.474113 14.8138 0.0150682 14.2753 0.00036206ZM1.73214 4.19239C0.824054 4.19239 0.0878906 4.95518 0.0878906 5.89598V8.96319C0.0878906 9.90438 0.824054 10.6675 1.73214 10.6675H4.69206V4.19239H1.73214ZM2.38997 11.8102C2.38997 13.4945 2.67596 14.9583 2.88456 15.5231C2.99187 15.813 3.25234 16 3.5424 16H4.91756C5.39144 16 5.73072 15.5123 5.59684 15.0232C5.41338 14.354 5.22331 12.9936 5.22331 11.8102H2.38997Z"
                            fill="#00B4FF"
                          />
                        </svg>
                      </span>
                      <span
                        className={style.black_link}
                        style={{
                          color: `${showAnnonces ? "#00B4FF" : "black"}`,
                        }}
                      >
                        {t("Publier une annonce")}
                      </span>
                    </span>
                    <span
                      style={{
                        padding: "16px",
                        borderLeft: "1px solid rgba(0, 0, 0, 0.16)",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <span
                        className={showAnnonces ? style.svg_down : style.svg_up}
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="Icon/Outline/chevron-right">
                            <path
                              id="Icon"
                              d="M19 9L12 16L5 9"
                              stroke="#00B4FF"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </svg>
                      </span>
                    </span>
                  </span>
                  {showAnnonces ? (
                    <ul
                      style={{
                        padding: "0px",
                        display: "flex",
                        flexDirection: "column",
                        // gap: "24px",
                        // paddingLeft: "45px",
                      }}
                    >
                      <li
                        className={style.subItem1}
                        style={{ paddingTop: "25px" }}
                      >
                        <a
                          data-tracking="click"
                          data-value=""
                          className={style.subitemtitle}
                          href="/user/annonces/publier"
                        >
                          {t("Publier une annonce")}
                        </a>
                      </li>
                      <li className={style.subItem}>
                        <a
                          data-tracking="click"
                          data-value=""
                          className={style.subitemtitle}
                          href="/user/annonces"
                        >
                          {t("Annonces publiées")}
                        </a>
                      </li>
                    </ul>
                  ) : null}
                </span>
              </li>
              <li className={style.MyItem}>
                <a
                  data-tracking="click"
                  data-value=""
                  className={style.myitemtitle1}
                  href={formatUrl(`/${lang}/user/inbox`, lang)}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span className={style.iconestimation}>
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="16"
                          cy="16"
                          r="16"
                          fill="#00B4FF"
                          fill-opacity="0.1"
                        />
                        <path
                          d="M12.0176 9C11.0414 9 10.1914 9.60714 9.95566 10.4723L8.06309 17.3907C8.01992 17.5455 8 17.7034 8 17.8612V20.6571C8 21.7288 8.95293 22.6 10.125 22.6H22.875C24.0471 22.6 25 21.7288 25 20.6571V17.8612C25 17.7034 24.9801 17.5455 24.9369 17.3907L23.0443 10.4723C22.8086 9.60714 21.9586 9 20.9824 9H12.0176ZM12.0176 10.9429H20.9824L22.5762 16.7714H20.8762C20.4744 16.7714 20.1059 16.9779 19.9266 17.3088L19.4518 18.177C19.2725 18.5048 18.9039 18.7143 18.5021 18.7143H14.5012C14.0994 18.7143 13.7309 18.5079 13.5516 18.177L13.0768 17.3088C12.8975 16.9809 12.5289 16.7714 12.1271 16.7714H10.4238L12.0176 10.9429Z"
                          fill="#00B4FF"
                        />
                      </svg>
                    </span>
                    <span className={style.black_link}>{t("Inbox")}</span>
                  </span>
                </a>
              </li>
              <li className={style.MyItem}>
                <a
                  data-tracking="click"
                  data-value=""
                  className={style.myitemtitle1}
                  rel="nofollow"
                  href={formatUrl(`/${lang}/user/settings`, lang)}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <span className={style.iconestimation}>
                      <svg
                        width="17"
                        height="18"
                        viewBox="0 0 17 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.9529 5.79618C17.0656 6.09887 16.9705 6.43634 16.7274 6.65204L15.2021 8.02281C15.2408 8.31157 15.2619 8.6073 15.2619 8.9065C15.2619 9.2057 15.2408 9.50143 15.2021 9.79019L16.7274 11.161C16.9705 11.3767 17.0656 11.7141 16.9529 12.0168C16.7979 12.4308 16.6112 12.8275 16.3963 13.2102L16.2307 13.492C15.9982 13.8747 15.7375 14.2365 15.4522 14.5774C15.2443 14.8279 14.8991 14.9114 14.5891 14.814L12.6269 14.1982C12.1549 14.5566 11.6335 14.8558 11.0769 15.0819L10.6366 17.0685C10.5661 17.3851 10.3195 17.6356 9.99541 17.6878C9.50927 17.7678 9.00904 17.8095 8.49824 17.8095C7.98744 17.8095 7.48721 17.7678 7.00106 17.6878C6.67697 17.6356 6.43038 17.3851 6.35992 17.0685L5.91957 15.0819C5.36298 14.8558 4.84161 14.5566 4.36956 14.1982L2.4109 14.8175C2.1009 14.9149 1.75567 14.8279 1.54782 14.5809C1.26248 14.24 1.0018 13.8781 0.769293 13.4954L0.603723 13.2136C0.388834 12.8309 0.202128 12.4343 0.047126 12.0203C-0.0656024 11.7176 0.0295122 11.3801 0.272583 11.1644L1.79794 9.79367C1.75919 9.50143 1.73805 9.2057 1.73805 8.9065C1.73805 8.6073 1.75919 8.31157 1.79794 8.02281L0.272583 6.65204C0.0295122 6.43634 -0.0656024 6.09887 0.047126 5.79618C0.202128 5.38217 0.388834 4.98555 0.603723 4.60285L0.769293 4.32104C1.0018 3.93834 1.26248 3.57652 1.54782 3.23556C1.75567 2.98507 2.1009 2.90157 2.4109 2.99899L4.37308 3.61479C4.84513 3.25644 5.3665 2.95724 5.9231 2.7311L6.36344 0.744528C6.4339 0.42793 6.68049 0.177434 7.00459 0.125248C7.49073 0.0417492 7.99096 0 8.50176 0C9.01256 0 9.5128 0.0417492 9.99894 0.121769C10.323 0.173955 10.5696 0.42445 10.6401 0.741049L11.0804 2.72762C11.637 2.95376 12.1584 3.25296 12.6304 3.61131L14.5926 2.99551C14.9026 2.89809 15.2479 2.98507 15.4557 3.23209C15.741 3.57304 16.0017 3.93486 16.2342 4.31757L16.3998 4.59937C16.6147 4.98207 16.8014 5.37869 16.9564 5.79271L16.9529 5.79618ZM8.50176 11.6898C10.0588 11.6898 11.32 10.4443 11.32 8.9065C11.32 7.36874 10.0588 6.12322 8.50176 6.12322C6.9447 6.12322 5.68355 7.36874 5.68355 8.9065C5.68355 10.4443 6.9447 11.6898 8.50176 11.6898Z"
                          fill="#00B4FF"
                        />
                      </svg>
                    </span>
                    <span className={style.black_link}>{t("Paramètres")}</span>
                  </span>
                </a>
              </li>
            </ul>
          )}
        </div>
      </div>
      <div className={style.bottomContainer}>
        <div className={style.buttonItems}>
          <a href={formatUrl("estimation/map", lang)}>
            {t("Estimez votre bien")}
          </a>
        </div>
        <div className={style.bottomItems}>
          <div>
            {/* <a
              data-tracking="click"
              data-value=""
              className={style.langItem}
              href={formatUrl(`/${lang}/offres-pro`, lang)}
            >
              <span style={{ padding: "0px 9px 0px 0px" }}>
                <svg
                  width="17"
                  height="18"
                  viewBox="0 0 17 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.43222 3.48666V5.32444H1.83778V15.4322H11.9456V10.8378H13.7833V16.3511C13.7833 16.8586 13.3719 17.27 12.8644 17.27H0.918889C0.411401 17.27 0 16.8586 0 16.3511V4.40555C0 3.89806 0.411401 3.48666 0.918889 3.48666H6.43222ZM16.54 0.729996V8.08111H14.7022V3.86616L7.54132 11.028L6.24201 9.72867L13.402 2.56777H9.18889V0.729996H16.54Z"
                    fill="black"
                  />
                </svg>
              </span>
              <span> {t("Offres pro")}</span>
            </a> */}
            {user && user?.id ? (
              <button
                className={style.Logoutbtn}
                style={{ backgroundColor: "transparent", color: "black" }}
                onClick={() => {
                  closeMenu();
                  dispatch(updateUser({ data: null }));
                  dispatch(signInR({ data: null }));
                  dispatch(setUID({ data: null }));
                  dispatch(setEmail({ data: null }));
                  dispatch(setUser({ data: null }));
                  localStorage.removeItem("FBIdToken");
                  localStorage.removeItem("RT");
                  nookies.set(undefined, "AccessToken", "", {
                    path: "/",
                  });
                  nookies.destroy(undefined, "AccessToken");
                  nookies.set(undefined, "FBIdToken", "", {
                    path: "/",
                  });
                  nookies.destroy(undefined, "FBIdToken");
                  nookies.set(undefined, "RT", "", {
                    path: "/",
                  });
                  nookies.destroy(undefined, "RT");
                }}
              >
                <span style={{ padding: "0px 9px 0px 0px" }}>
                  <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.9756 0.561066C11.4385 0.561066 11.8022 0.924747 11.8022 1.38761V3.86726H10.1491V2.21416H1.8836V13.7858H10.1491V12.1327H11.8022V14.6124C11.8022 15.067 11.4385 15.4389 10.9756 15.4389H1.05706C0.602453 15.4389 0.230507 15.067 0.230507 14.6124V1.38761C0.230507 0.924747 0.602453 0.561066 1.05706 0.561066H10.9756ZM13.6458 4.48717L13.6296 4.51946L16.5225 7.4043C16.8532 7.72666 16.8532 8.24751 16.5225 8.56986L13.6296 11.4628L12.4641 10.2891L13.9267 8.82655H6.01634V7.17345H13.9783L12.4721 5.6608L13.6458 4.48717Z"
                      fill="black"
                    />
                  </svg>
                </span>
                {logingOut ? (
                  <i className="fas fa-circle-notch fa-spin"></i>
                ) : (
                  t("Se déconnecter")
                )}
              </button>
            ) : null}
            {!user?.id ? (
              <div
                className={style.Logoutbtn}
                onClick={() => {
                  closeMenu();
                  if (openLoginModal) {
                    openLoginModal();
                  }
                }}
              >
                <span>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g id="Icon/Outline/user-circle">
                      <path
                        id="Icon"
                        d="M5.12104 17.8037C7.15267 16.6554 9.4998 16 12 16C14.5002 16 16.8473 16.6554 18.879 17.8037M15 10C15 11.6569 13.6569 13 12 13C10.3431 13 9 11.6569 9 10C9 8.34315 10.3431 7 12 7C13.6569 7 15 8.34315 15 10ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                        stroke="#00111A"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                  </svg>
                </span>
                <span>{t("Se connecter")}</span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileDrawerv3;
